export default "__VITE_PUBLIC_ASSET__1fd64b79__"